export default __webpack_public_path__ + "static/MediaContentFour-c2307699553fb4a3ee1c3602c27b932d.webp";